/**
 * Created by eriksundqvist on 12/10/16.
 */
export default class InvoiceHsdEntity {

  constructor (
      rot,
      rut,
      data,
      apartmentNumber,
      cooperativeApartmentRegistrationNumber,
      accommodationType,

  ) {
    this.rot = rot;
    this.rut = rut;
    this.data = data;
    this.apartmentNumber = apartmentNumber;
    this.cooperativeApartmentRegistrationNumber = cooperativeApartmentRegistrationNumber;
    this.accommodationType = accommodationType;
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/invoices/invoice-hsd-entity.js
 **/